import { render } from "./powerStation.vue?vue&type=template&id=571a1cdd&scoped=true"
const script = {}

import "./powerStation.vue?vue&type=style&index=0&id=571a1cdd&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571a1cdd"]])

export default __exports__